import { render, staticRenderFns } from "./ResolvedIncidents.vue?vue&type=template&id=d824c64e&scoped=true&"
import script from "./ResolvedIncidents.vue?vue&type=script&lang=js&"
export * from "./ResolvedIncidents.vue?vue&type=script&lang=js&"
import style0 from "./ResolvedIncidents.vue?vue&type=style&index=0&id=d824c64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d824c64e",
  null
  
)

export default component.exports